const REDIRECT_URI = `${process.env.REACT_APP_PUBLIC_URL}/authorized`;

const Constants = {
  BACKEND_API_URL: process.env.REACT_APP_RESOURCE_URL,
  AUTH_URL: `${process.env.REACT_APP_AUTH_URL}/oauth2/authorize?response_type=code&client_id=${process.env.REACT_APP_AUTH_CLIENT_ID}&scope=${process.env.REACT_APP_AUTH_SCOPE}&redirect_uri=${REDIRECT_URI}`,
  REDIRECT_URI,
  TOKEN_URL: `${process.env.REACT_APP_AUTH_URL}/oauth2/token`,
};

export default Constants;
